/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
 */
export interface CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner {
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'amountFx': number;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'totalAmountFx': number;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'currencyCode': string;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'fxRate': number | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'transactionDetailType': CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner
     */
    'isCleared': boolean;
}

export const CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = {
    purchase: 'PURCHASE',
    settlement: 'SETTLEMENT',
    validation: 'VALIDATION',
    refund: 'REFUND',
    cancel: 'CANCEL',
    refundCancel: 'REFUND_CANCEL',
    refundPartialCancel: 'REFUND_PARTIAL_CANCEL'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum = typeof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInnerTransactionDetailTypeEnum];


